/* Shared theme helpers for the home dashboard widgets.
 *
 * The widgets state status in colour - green for balanced/up to date, orange for action needed,
 * red for out of balance - using Vuetify's `darken-N` text helpers. Those shades were picked
 * against a white card. On the dark theme the same class lands on #1e1e1e, where `green
 * darken-1` is about 3.9:1 and `red darken-2` about 3.3:1, both under the 4.5:1 minimum for the
 * small bold labels they are used on. A widget asks for a tone here and gets the shade that
 * carries on the surface it is actually drawn on.
 *
 * toneColor() is for `:color` on v-icon and for text - it returns a legible *foreground*. Do not
 * feed it to a filled v-btn: those paint white on the colour, so a lighten-2 fill would be the
 * unreadable direction. Filled buttons keep their saturated colour in both themes.
 */
const TONES = {
  green: ['green darken-1', 'green lighten-2'],
  orange: ['orange darken-1', 'orange lighten-2'],
  'deep-orange': ['deep-orange darken-1', 'deep-orange lighten-2'],
  red: ['red darken-2', 'red lighten-2'],
  blue: ['blue darken-1', 'blue lighten-2'],
  grey: ['grey darken-1', 'grey lighten-1'],
};

export default {
  computed: {
    isDark() {
      return this.$vuetify.theme.dark;
    },
  },
  methods: {
    // 'green' -> 'green darken-1' (light) | 'green lighten-2' (dark)
    toneColor(tone) {
      const pair = TONES[tone] || TONES.grey;
      return this.isDark ? pair[1] : pair[0];
    },
    // 'green' -> 'green--text text--darken-1' (light) | 'green--text text--lighten-2' (dark)
    toneText(tone) {
      const [hue, shade] = this.toneColor(tone).split(' ');
      return `${hue}--text text--${shade}`;
    },
  },
};
